import React, { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import MainLayout from "../../components/Layout/MainLayout";
import NotFound from "../../pages/NotFound";

// Lazy load components for better performance
const Dashboard = lazy(() => import("../features/Dashboard"));
const Amc = lazy(() => import("../features/Amc"));
const SurveyDetails = lazy(() => import("../features/Surveys"));
const AmcDetails = lazy(() => import("../features/amc/AmcDetails"));
const Contact = lazy(() => import("../features/Contact"));
const ActiveAMC = lazy(() => import("../features/ActiveAMC"));
const Reports = lazy(() => import("../features/Reports"));
const FormA = lazy(() => import("../../superadmin/features/reports/FormA"));
const FormB = lazy(() => import("../../superadmin/features/reports/FormB"));
const TrainingCertificateForm = lazy(() => import("../../superadmin/features/reports/TrainingCertificate"));
const TestingCertificateForm = lazy(() => import("../../superadmin/features/reports/TestingCertificateForm"));
const InstallationCertificateForm = lazy(() => import("../../superadmin/features/reports/InstallationCertificateForm"));
const AmcExport = lazy(() => import("../features/amc/AmcExport"));
const CustomerLicenseCopyView = lazy(() => import("../features/LicenseCopyView"));

// Reusable route wrapper component
const RouteWrapper = ({ active, children }) => (
  <MainLayout active={active}>
    <Suspense fallback={<div>Loading...</div>}>
      {children}
    </Suspense>
  </MainLayout>
);

// Route configuration objects
const dashboardRoutes = [
  { path: "/dashboard", component: Dashboard },
];

const surveyRoutes = [
  { path: "/surveys", component: SurveyDetails },
];

const amcRoutes = [
  { path: "/amcs", component: Amc },
  { path: "/amcs/active", component: ActiveAMC },
  { path: "/amcs/:amcId", component: AmcDetails },
  { path: "/amcs/:amcId/export", component: AmcExport },
];

const reportRoutes = [
  { path: "/reports", component: Reports },
  { path: "/view/formA/:id", component: FormA, props: { view: true } },
  { path: "/view/formB/:id", component: FormB, props: { view: true } },
  { path: "/view/trainingCertificate/:id", component: TrainingCertificateForm, props: { view: true } },
  { path: "/view/testingCertificate/:id", component: TestingCertificateForm, props: { view: true } },
  { path: "/view/installationCertificate/:id", component: InstallationCertificateForm, props: { view: true } },
];

const licenseCopyRoutes = [
  { path: "/licenseCopies/:id", component: CustomerLicenseCopyView },
];

const contactRoutes = [
  { path: "/contact", component: Contact },
];

// Helper function to create routes
const createRoutes = (routes, active) => {
  return routes.map(({ path, component: Component, props = {} }) => (
    <Route
      key={path}
      path={path}
      element={
        <RouteWrapper active={active}>
          <Component {...props} />
        </RouteWrapper>
      }
    />
  ));
};

const CustomerRoutes = () => {
  return (
    <Routes>
      {createRoutes(dashboardRoutes, "dashboard")}
      {createRoutes(surveyRoutes, "surveys")}
      {createRoutes(amcRoutes, "amcs")}
      {createRoutes(reportRoutes, "reports")}
      {createRoutes(licenseCopyRoutes, "licenseCopies")}
      {createRoutes(contactRoutes, "contact")}
      <Route path="/:notfound" element={<NotFound />} />
    </Routes>
  );
};

export default CustomerRoutes;
